(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8246],{

/***/ 87840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tienda/[slug]",
      function () {
        return __webpack_require__(38609);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4351);
/* harmony import */ var ab_pdp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3663);
/* harmony import */ var ab_seo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38293);
/* harmony import */ var ab_configurador_estuches__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40366);
/* harmony import */ var _components_DynamicContent__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44517);









var Home = function(param) {
    var _content = param.content, content = _content === void 0 ? [] : _content, category = param.category, product = param.product, moduloCross = param.moduloCross, personalizacion = param.personalizacion, etiquetaSKU = param.etiquetaSKU;
    var ref;
    var i18n = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common").i18n;
    ;
    if (product === null || product === void 0 ? void 0 : (ref = product.configuradorEstuches) === null || ref === void 0 ? void 0 : ref.numeroBotellas) {
        var ref1, ref2;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_seo__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    seo: {
                        title: "".concat(product === null || product === void 0 ? void 0 : product.name, " | ").concat(product === null || product === void 0 ? void 0 : (ref1 = product.productCategories) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.nodes) === null || ref2 === void 0 ? void 0 : ref2[0].name, " | Abad\xeda Retuerta"),
                        description: "Compra en nuestra tienda online un/una ".concat(product === null || product === void 0 ? void 0 : product.name, ". Los mejores productos exclusivos para tu disfrute. Env\xedo Gratis a partir de 100$. ")
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_configurador_estuches__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, product), {
                    i18n: i18n,
                    personalizacion: personalizacion,
                    etiquetaSKU: etiquetaSKU
                }))
            ]
        });
    } else if (product === null || product === void 0 ? void 0 : product.name) {
        var ref3, ref4;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_seo__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    seo: {
                        title: "".concat(product === null || product === void 0 ? void 0 : product.name, " | ").concat(product === null || product === void 0 ? void 0 : (ref3 = product.productCategories) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.nodes) === null || ref4 === void 0 ? void 0 : ref4[0].name, " | Abad\xeda Retuerta"),
                        description: "Compra en nuestra tienda online un/una ".concat(product === null || product === void 0 ? void 0 : product.name, ". Los mejores productos exclusivos para tu disfrute. Env\xedo Gratis a partir de 100$. ")
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_pdp__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, product), {
                    i18n: i18n,
                    personalizacion: personalizacion,
                    etiquetaSKU: etiquetaSKU
                }))
            ]
        });
    } else if (content.length > 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: content === null || content === void 0 ? void 0 : content.map(function(itm, index) {
                return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_components_DynamicContent__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, itm), {
                    category: category,
                    rtl: index % 2 !== 1,
                    moduloCross: moduloCross,
                    key: "".concat(itm.fieldGroupName, "-").concat(index),
                    i18n: i18n
                }));
            })
        });
    }
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7117,4517,3663,366,9774,2888,179], function() { return __webpack_exec__(87840); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);